import { render, staticRenderFns } from "./instructionaldesign.vue?vue&type=template&id=cb90d9c0&scoped=true"
import script from "./instructionaldesign.vue?vue&type=script&lang=js"
export * from "./instructionaldesign.vue?vue&type=script&lang=js"
import style0 from "./instructionaldesign.vue?vue&type=style&index=0&id=cb90d9c0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb90d9c0",
  null
  
)

export default component.exports